Service = App.loadClass 'core::Angular/Service'

class exports.CompaniesService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getCompaniesData: () =>
        @http.post 'backend/admin/new-tools/companies/list-companies'

    getPagesForCompany: (companyId) =>
        @http.post 'backend/admin/new-tools/companies/list-companies-pages',
            id: companyId

    getReportsForCompany: (companyId) =>
        @http.post 'backend/admin/new-tools/companies/list-companies-reports',
            id: companyId

    getLineupsForCompany: (companyId) =>
        @http.post 'backend/admin/new-tools/companies/list-companies-lineups',
            id: companyId

    getAllCrops: () =>
        @http.post 'backend/admin/new-tools/companies/list-all-crops'

    getAllSeedCompanies: () =>
        @http.post 'backend/admin/new-tools/companies/list-all-seed-companies'

    saveSeedCompany: (pretend, name, country) =>
        @http.post 'backend/admin/new-tools/companies/save-seed-company', { pretend, name, country }

    createNewCompany: (
        username
        company
        password
        phone
        email
        address1
        address2
        city
        state
        zipcode
    ) =>
        @http.post 'backend/admin/new-tools/companies/create-new-company',
            username: username
            company: company
            password: password
            phone: phone
            email: email
            address1: address1
            address2: address2
            city: city
            state: state
            zipcode: zipcode

    saveCompanyPagesAndReports: (companyId, pages, reports) =>
        @http.post 'backend/admin/new-tools/companies/save-company-pages-and-reports',
            id: companyId
            pages: pages
            reports: reports

    saveCompanyLineups: (companyId, lineups) =>
        @http.post 'backend/admin/new-tools/companies/save-company-lineups',
            id: companyId
            lineups: lineups
